'use client';
// Founder 2026-09-27: "מומחים שנצפו X/Y" — an expert counts as VIEWED when their card is actually on screen (category list,
// article/pro widgets) or their page is opened. Fires one `pro_view` event per expert per page; the analytics API counts
// distinct experts per visit against every active expert of the categories the visit touched.
import { useEffect, useRef } from 'react';
import { trackEvent } from './Tracker';
export default function ProViewBeacon({ id, name, categorySlug, immediate = false }: { id: number; name?: string | null; categorySlug?: string | null; immediate?: boolean }) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!id) return;
    const slug = categorySlug || (() => { try { return decodeURIComponent(location.pathname.split('/')[1] || '') || null; } catch { return null; } })();
    const key = `pv:${id}:${location.pathname}`;
    const fire = () => { try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch {} trackEvent('pro_view', { professionalId: id, professionalName: name || null, categorySlug: slug }); };
    if (immediate || !('IntersectionObserver' in window) || !ref.current) { fire(); return; }
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { fire(); io.disconnect(); } }, { threshold: 0.4 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [id, name, categorySlug, immediate]);
  return <span ref={ref} aria-hidden style={{ display: 'block', width: 1, height: 1 }} />;
}
